import React, { useEffect, useCallback, useState} from 'react';
import {useEffects} from './useEffects.js';
import EffectComponent from 'components/effects/EffectComponent.js';
import TrackEffects from "components/mix/mix2/TrackEffects.js";
import OutputChannelChooser from '../OutputChannelChooser.js';
import GroupActions from './GroupActions.js';
import Colors from 'components/Colors.js';
import VolumeSlider from './VolumeSlider.js';
import {setGroupCollapsed} from 'actions/index.js';
import {connect} from 'react-redux';

const colors = new Colors();

const GroupVolumeControl = ({
    group,
    volume,
    isCollapsed,
    setGroupCollapsed,
    selectedTrack,
    selectedGroup,
    selectedEffect
}) => { 
    let {groupNumber} = group;

    const {onDeleteEffect, effects} = useEffects({trackOrGroup: group});
    const color = colors.getColorForTrack(group.tracks[0]);
    const setVolume = useCallback(v => {
        group.setVolume(v);
    }, [group]);

    let style = {
    };
    let infoStyle = {};
    let nameStyle ={};

    if (selectedGroup === group.groupNumber) {
        infoStyle.backgroundColor = color;
        infoStyle.color = 'black';
        style.borderStyle = "solid";
        style.borderColor = color;
    } else {
        style.borderColor = color;
        style.backgroundColor = 'unset';
        style.backgroundImage = 'unset';
        style.borderStyle = "solid";
        infoStyle.color = "white";
    }

    let className = "group-volume-control"
    if (selectedEffect) {
        className += " showing";
    }

    return (
        <div
          style={style}
          className={className}>
          <div style={infoStyle} className="group-info">
            <div className="group-name">
              Group {groupNumber + 1}
            </div>
            <div
              onClick={() => setGroupCollapsed(!isCollapsed)}
              className="collapse-toggle">
              {isCollapsed ? <div className="arrow-down"/> : <div className="arrow-right"/>}
            </div>
          </div>
          {selectedEffect ?
           <EffectComponent
             onDeleteEffect={onDeleteEffect}
             sequencerEngine={group.sequencerEngine}
             group={group}
             compact={true}
             effect={selectedEffect}
                              send={undefined}/>  : 
           <VolumeSlider volume={volume} setVolume={setVolume}/>}
          <GroupActions group={group}/>
          {!group.sequencerEngine.channelMixer.stereoConnected ? 
           <OutputChannelChooser channel={group}/>
           : ''}
          <TrackEffects effects={effects} track={group}/>

        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      volume: state.tracks.groupVolumes[props.group.groupNumber],
      isCollapsed: state.mix.groupCollapsed[props.group.subSequence.id] &&
          state.mix.groupCollapsed[props.group.subSequence.id][props.group.groupNumber],
      selectedTrack: state.mix.selectedTrack,
      selectedGroup: state.mix.selectedGroup,
      selectedEffect: props.group!== undefined && state.mix.selectedTrackEffects[props.group.subSequence.id] &&
          state.mix.selectedTrackEffects[props.group.subSequence.id][props.group.id],
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setGroupCollapsed: (collapsed) => dispatch(setGroupCollapsed(
          props.group.subSequence.id,
          props.group.groupNumber,
          collapsed)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupVolumeControl);
